import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/browse-products")({
  validateSearch: (search: Record<string, unknown>): {
    category?: string
    source?: string
  } => ({
    category: (search.category as string) || undefined,
    source: (search.source as string) || undefined,
  }),
})